/**
 * StudentLiveSessionsListScreen — « Tous mes lives » de l'élève (`live-sessions-list`, patron A).
 *
 * La page du parent (`<LiveSessionsListPage>`), dite à l'élève (`voice="student"`), et ses données :
 * la même lecture (`useLiveSessionsListData`, `getAllMyNextLiveSessions` sans e-mail d'enfant) et la
 * même liste (`studentLiveSessionsListViewModel`, posé sur celui du parent). Remplace, interrupteur
 * allumé, l'ancien écran (`student/tutoring/LiveSessionsListScreen.js`), qui reste celui du parent et
 * du tuteur sur cette route partagée.
 *
 * Depuis que les prochains lives ont quitté « Messages » (Wajih, 18/10), la liste porte tous les
 * gestes de l'élève sur une séance, « GO ! » compris, et « Planifier un rattrapage »
 * (`useStudentLiveSessionsListState`). Une séance suspendue pour paiement n'en a aucun : la toucher
 * ouvre la boîte du paiement, comme pour le parent (Wajih, 19/10). Fermer : l'écran d'avant, sinon
 * `menu`.
 */
import React from "react"
import { useSelector } from "react-redux"

import { LiveSessionsListPage } from "../../../../../../design-system"
import { STUDENT_SESSION_ACTIONS_WITH_JOIN } from "../../../../../../design-system/student"
import { studentLiveSessionsListViewModel } from "../../../../view-models/student/Tutoring/studentLiveSessionsListViewModel"
import { useLiveSessionsListData } from "../../parent/LiveSessions/useLiveSessionsListData"
import { StudentLiveSessionsListDialogs } from "./StudentLiveSessionsListDialogs"
import { useStudentLiveSessionsListState } from "./useStudentLiveSessionsListState"

export function StudentLiveSessionsListScreen() {
    const { refresh } = useLiveSessionsListData(null)
    const vm = useSelector(studentLiveSessionsListViewModel)
    const gestures = useStudentLiveSessionsListState({
        sessions: vm.sessions,
        enrolledSessionIds: vm.enrolledSessionIds,
        paymentUrl: vm.paymentUrl,
        refresh,
    })
    const { actions } = gestures

    return (
        <>
            <LiveSessionsListPage
                voice="student"
                allowedActions={STUDENT_SESSION_ACTIONS_WITH_JOIN}
                groups={vm.groups}
                loading={vm.loading}
                error={vm.error}
                onRetry={refresh}
                onClose={actions.close}
                onSessionAction={actions.onSessionAction}
                // Une séance suspendue n'ouvre pas sa feuille : seulement la boîte du paiement.
                onBlockedSessionPress={actions.onBlockedSessionPress}
                onFinishedSessionPress={actions.onFinishedSessionPress}
                onPlanRecovery={vm.hasAbsencesToRecover ? actions.planRecovery : undefined}
                recoverableNowCount={vm.recoverableNowCount}
            />
            <StudentLiveSessionsListDialogs {...gestures} />
        </>
    )
}
